export const replaceParagraphJson = (content = []) => content.map((node) => {
  if (node.type === 'paragraph') {
    return {
      ...node,
      type: 'heading',
      attrs: { level: 3 },
    };
  }

  return node;
});

export const replaceParagraphHtml = (html = '') => {
  if (!html) {
    return '<h3></h3>';
  }

  return html
    .replace(/<p(\W)/ig, '<h3$1')
    .replace(/<\/p>/ig, '</h3>');
};
